import React from "react";
import { useParams, useLocation } from "react-router";

function withParams(Component) {
    return function WrappedComponent(props) {
        const { pathname } = useLocation();
        const { tenant = "", listName, id } = useParams();
        const resolvedTenant = tenant === "" ? pathname.split('/')[1] : tenant;

        return <Component {...props} params={{ tenant: resolvedTenant, listName, id }} />;
    };
}

interface ITenant {
    tenant: string;
}

interface IProps {
    params: ITenant;
}

class Sitemap extends React.Component<IProps> {
    componentDidMount() {
        let { tenant } = this.props.params;
        window.location.href = `${process.env.REACT_APP_API_URL}/jobs/${tenant}/sitemap.xml`
    }

    render(): React.ReactNode { return (<>Redirecting...</>) }
}

export default withParams(Sitemap);